// @flow

import React from 'react';

// header

type Props = {
    color: string,
    status: string
};

const InjuryStatus = (props: Props) => {
    const display = (
        <span>
            <i className={'fas fa-medkit'} style={{ color: props.color, paddingRight: '3px' }} title={props.status} />
        </span>
    );

    return display;
};

export default InjuryStatus;



// WEBPACK FOOTER //
// ./src/components/UI/InjuryStatus.js